const declarationTextFallback = {
    nominationOptOutSentence: {
        'en': 'am willing to open Trading and Demat account with Motilal Oswal. All signatures on Form and supporting documents are done by me.',
        'hi': 'मुझे अपने खाते में कोई नामांकित व्यक्ति नहीं जोड़ना है',
        'gu': 'હું મારા ખતા મા નોમિની ઉમેરવા માંગતો નથી',
        'mr': 'मला माझ्या खात्यात नॉमिनी जोडायचे नाही',
        'ta': 'நான் என் கணக்கிற்கு நியமிக்கப்பட்டவரை சேர்க்க விரும்பவில்லை',
        'te': 'నేను నా ఖాతాకు నామినీని జోడించలేను',
        'kn': 'ನಾನು ನನ್ನ ಖಾತೆಗೆ ನಮೂದಿತ ವ್ಯಕ್ತಿಯನ್ನು ಸೇರಿಸಲು ಇಚ್ಛಿಸುವುದಿಲ್ಲ',
        'ml': 'ഞാൻ എന്റെ അക്കൗണ്ടിന് നാമനിർദേശിതനെ ചേർക്കാൻ ആഗ്രഹിക്കുന്നില്ല',
        'bn': 'আমি আমার অ্যাকাউন্টে কোনও নমিনি যোগ করতে চাই না।',
    },
    nominationOptOutRequest: {
        'en': 'Nomination Opt Out Request',
        'hi': 'नामांकन हटाने का अनुरोध',
        'gu': 'નામ ભરતી ટાળો વિનંતી',
        'mr': 'नामांकन वगळण्याची विनंती',
        'ta': 'நியமனத்தை இரத்து செய்யவும்',
        'te': 'నామినేషన్ వృథా అభ్యర్థన',
        'kn': 'ನಾಮನಿರ್ದೇಶನ ತಿರಸ್ಕಾರ ವಿನಂತಿ',
        'ml': 'നാമനിർദേശം ഒഴിവാക്കൽ അപേക്ഷ',
        'bn': 'নামাঙ্কন ছাড়াই অনুরোধ',
    },
    pleaseReadDeclaration: {
        'en': 'Please read the below declaration',
        'hi': 'कृपया नीचे दिए गए घोषणा-पत्र को पढ़ें',
        'gu': 'કૃપા કરીને નીચે આપેલી જાહેરાત વાંચો',
        'mr': 'कृपया खालील घोषणा वाचा',
        'ta': 'தயவுசெய்து கீழே உள்ள அறிக்கையை படியுங்கள்',
        'te': 'దయచేసి దిగువ ప్రకటనను చదవండి',
        'kn': 'ದಯವಿಟ್ಟು ಕೆಳಗಿನ ಘೋಷಣೆಯನ್ನು ಓದರಿರಿ',
        'ml': 'ദയവായി താഴെയുള്ള പ്രഖ്യാപനം വായിക്കുക',
        'bn': 'অনুগ্রহ করে নিচের ঘোষণা পড়ুন',
    },
    startRecordingLan: {
        'en': 'Start',
        'hi': 'शुरू करें',
        'gu': 'શરૂ કરો',
        'mr': 'सुरू करा',
        'ta': 'தொடங்கு',
        'te': 'ప్రారম্ভం',
        'kn': 'ಪ್ರಾರಂಭ',
        'ml': 'ആരംഭിക്കുക',
        'bn': 'শুরু',
    },
    stopRecordingLan: {
        'en': 'Stop',
        'hi': 'रोकें',
        'gu': 'રોકો',
        'mr': 'थांबवा',
        'ta': 'நிறுத்து',
        'te': 'నిలుపు',
        'kn': 'ನಿಲ್ಲಿಸಿ',
        'ml': 'നിർത്തുക',
        'bn': 'বন্ধ',
    },
    retake: {
        'en': 'Retake',
        'hi': 'फिर से करें',
        'gu': 'ફરીથી કરો',
        'mr': 'पुन्हा करा',
        'ta': 'மீண்டும் செய்யவும்',
        'te': 'మళ్లీ చేయండి',
        'kn': 'ಮತ್ತೆ ಮಾಡಿ',
        'ml': 'വീണ്ടും ചെയ്യുക',
        'bn': 'আবার করুন',
    },
    pleaseSelectLanguage: {
        'en': 'Please select a language and click on the start button.',
        'hi': 'कृपया एक भाषा चुनें और स्टार्ट बटन पर क्लिक करें।',
        'gu': 'કૃપા કરીને એક ભાષા પસંદ કરો અને સ્ટાર્ટ બટન પર ક્લિક કરો।',
        'mr': 'कृपया एक भाषा निवडा आणि स्टार्ट बटनावर क्लिक करा।',
        'ta': 'தயவுசெய்து ஒரு மொழியைத் தேர்ந்தெடுத்து தொடக்க பொத்தானை அழுத்தவும்.',
        'te': 'దయచేసి ఒక భాషను ఎంచుకొని స్టార్ట్ బటన్‌పై క్లిక్ చేయండి.',
        'kn': 'ದಯವಿಟ್ಟು ಒಂದು ಭಾಷೆಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ ಮತ್ತು ಪ್ರಾರಂಭ ಬಟನ್ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ.',
        'ml': 'ദയവായി ഒരു ഭാഷ തിരഞ്ഞെടുത്ത് സ്റ്റാർട്ട് ബട്ടണിൽ ക്ലിക്ക് ചെയ്യുക.',
        'bn': 'অনুগ্রহ করে একটি ভাষা নির্বাচন করুন এবং স্টার্ট বোতামে ক্লিক করুন।',
    },
    analyzingVideo: {
        'en': 'Analyzing video, please wait...',
        'hi': 'वीडियो का विश्लेषण कर रहे हैं, कृपया प्रतीक्षा करें...',
        'gu': 'વીડિયોનું વિશ્લેષણ કરી રહ્યા છીએ, કૃપા કરીને રાહ જુઓ...',
        'mr': 'व्हिडिओचे विश्लेषण करत आहोत, कृपया प्रतीक्षा करा...',
        'ta': 'வீடியோ பகுப்பாய்வு செய்கிறோம், தயவுசெய்து காத்திருக்கவும்...',
        'te': 'వీడియో విశ్లేషణ చేస్తున్నాము, దయచేసి వేచి ఉండండి...',
        'kn': 'ವೀಡಿಯೊ ವಿಶ್ಲೇಷಣೆ ಮಾಡುತ್ತಿದ್ದೇವೆ, ದಯವಿಟ್ಟು ಕಾಯಿರಿ...',
        'ml': 'വീഡിയോ വിശകലനം ചെയ്യുന്നു, ദயവായി കാത്തിരിക്കുക...',
        'bn': 'ভিডিও বিশ্লেষণ করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    },
    selectLanguage: {
        'en': 'Select',
        'hi': 'चुनें',
        'gu': 'પસંદ કરો',
        'mr': 'निवडा',
        'ta': 'தேர்ந்தெடுக்கவும்',
        'te': 'ఎంచుకోండి',
        'kn': 'ಆಯ್ಕೆಮಾಡಿ',
        'ml': 'തിരഞ്ഞെടുക്കുക',
        'bn': 'নির্বাচন করুন',
    },
    attemptsRemaining: {
        'en': 'Attempts remaining',
        'hi': 'प्रयास शेष',
        'gu': 'પ્રયાસ બાકી',
        'mr': 'प्रयत्न शिल्लक',
        'ta': 'மீதமுள்ள முயற்சிகள்',
        'te': 'మిగిలిన ప్రయత్నాలు',
        'kn': 'ಉಳಿದಿರುವ ಪ್ರಯತ್ನಗಳು',
        'ml': 'ശേഷിക്കുന്ന ശ്രമങ്ങൾ',
        'bn': 'অবশিষ্ট প্রচেষ্টা',
    },
    allAttemptsUsed: {
        'en': "You've used all 3 tries.",
        'hi': 'आपने सभी 3 प्रयासों का उपयोग कर लिया है।',
        'gu': 'તમે બધા 3 પ્રયાસોનો ઉપયોગ કરી લીધો છે.',
        'mr': 'तुम्ही सर्व 3 प्रयत्न वापरले आहेत.',
        'ta': 'நீங்கள் அனைத்து 3 முயற்சிகளையும் பயன்படுத்தி விட்டீர்கள்.',
        'te': 'మీరు అన్ని 3 ప్రయత్నాలను ఉపయోగించారు.',
        'kn': 'ನೀವು ಎಲ್ಲಾ 3 ಪ್ರಯತ್ನಗಳನ್ನು ಬಳಸಿದ್ದೀರಿ.',
        'ml': 'നിങ്ങൾ എല്ലാ 3 ശ്രമങ്ങളും ഉപയോഗിച്ചു കഴിഞ്ഞു.',
        'bn': 'আপনি সমস্ত 3 প্রচেষ্টা ব্যবহার করেছেন।',
    }
    ,
   retakeMessage: {
    'en': 'It seems there was a small mistake. Kindly read the text again and try.',
    'hi': 'ऐसा लगता है कि एक छोटी सी गलती हुई है। कृपया पाठ दोबारा पढ़कर प्रयास करें।',
    'gu': 'લાગે છે કોઈ નાની ભૂલ થઈ છે. કૃપા કરીને લખાણ ફરી વાંચી ફરી પ્રયત્ન કરો.',
    'mr': 'असं दिसतं की एक छोटीशी चूक झाली आहे. कृपया मजकूर पुन्हा वाचून प्रयत्न करा.',
    'ta': 'சிறிய தவறு ஏற்பட்டிருக்கலாம். தயவுசெய்து உரையை மீண்டும் படித்து முயற்சிக்கவும்.',
    'te': 'చిన్న పొరపాటు జరిగినట్లు కనిపిస్తోంది. దయచేసి పాఠ్యాన్ని మళ్లీ చదివి ప్రయత్నించండి.',
    'kn': 'ಸಣ್ಣ ತಪ್ಪು ಸಂಭವಿಸಿದಂತಿದೆ. ದಯವಿಟ್ಟು ಪಠ್ಯವನ್ನು ಮತ್ತೆ ಓದಿ ಪ್ರಯತ್ನಿಸಿ.',
    'ml': 'ഒരു ചെറിയ പിഴവ് സംഭവിച്ചിരിക്കുന്നത് പോലെ തോന്നുന്നു. ദയവായി ടെക്സ്റ്റ് വീണ്ടും വായിച്ച് ശ്രമിക്കുക.',
    'bn': 'মনে হচ্ছে একটি ছোট ভুল হয়েছে। দয়া করে পাঠটি আবার পড়ে চেষ্টা করুন।',
},
    cameraInstruction: {
        'en': 'Keep your face inside the circle. Hold the camera steady and use good lighting.',
        'hi': 'अपना चेहरा घेरे के अंदर रखें। कैमरा स्थिर रखें और अच्छी रोशनी का उपयोग करें।',
        'gu': 'તમારો ચહેરો વર્તુળની અંદર રાખો. કેમેરાને સ્થિર રાખો અને સારી લાઇટિંગનો ઉપયોગ કરો.',
        'mr': 'तुमचा चेहरा वर्तुळाच्या आत ठेवा. कॅमेरा स्थिर धरा आणि चांगल्या प्रकाशाचा वापर करा.',
        'ta': 'உங்கள் முகத்தை வட்டத்துக்குள் வைத்திருங்கள். கேமராவை நிலையாக பிடித்து நல்ல விளக்கை பயன்படுத்துங்கள்.',
        'te': 'మీ ముఖాన్ని వృత్తం లోపల ఉంచండి. కెమెరాను స్థిరంగా పట్టుకుని మంచి లైటింగ్‌ను ఉపయోగించండి.',
        'kn': 'ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದ ಒಳಗೆ ಇಡಿ. ಕ್ಯಾಮೆರಾವನ್ನು ಸ್ಥಿರವಾಗಿ ಹಿಡಿದು ಉತ್ತಮ ಬೆಳಕನ್ನು ಬಳಸಿ.',
        'ml': 'മുഖം വൃത്തത്തിനുള്ളിൽ സൂക്ഷിക്കുക. ക്യാമറ ഉറച്ചുപിടിച്ച് നല്ല ലൈറ്റിംഗ് ഉപയോഗിക്കുക.',
        'bn': 'আপনার মুখটি বৃত্তের ভিতরে রাখুন। ক্যামেরা স্থিরভাবে ধরুন এবং ভালো আলো ব্যবহার করুন।',
    },
    centerFaceInstruction: {
        'en': 'Please center your face in the circle',
        'hi': 'कृपया अपना चेहरा घेरे के केंद्र में रखें',
        'gu': 'કૃપા કરીને તમારો ચહેરો વર્તુળના કેન્દ્રમાં રાખો',
        'mr': 'कृपया तुमचा चेहरा वर्तुळाच्या मध्यभागी ठेवा',
        'ta': 'தயவுசெய்து உங்கள் முகத்தை வட்டத்தின் மையத்தில் வைத்து கொள்ளுங்கள்',
        'te': 'దయచేసి మీ ముఖాన్ని వృత్తం మధ్యలో ఉంచండి',
        'kn': 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದ ಮಧ್ಯದಲ್ಲಿ ಇಡಿ',
        'ml': 'ദയവായി നിങ്ങളുടെ മുഖം വൃത്തത്തിന്റെ മദ്ധ്യത്തിൽ വയ്ക്കുക',
        'bn': 'অনুগ্রহ করে আপনার মুখটি বৃত্তের কেন্দ্রে রাখুন',
    },
    keepFaceInstruction: {
        'en': 'Keep your face in the circle, hold your phone at a comfortable distance',
        'hi': 'अपना चेहरा घेरे में रखें और अपना फ़ोन उचित दूरी पर रखें',
        'gu': 'તમારો ચહેરો વર્તુળમાં રાખો અને તમારો ફોન આરામદાયક અંતરે રાખો',
        'mr': 'तुमचा चेहरा वर्तुळात ठेवा आणि तुमचा फोन योग्य अंतरावर धरा',
        'ta': 'உங்கள் முகத்தை வட்டத்திற்குள் வைத்துக்கொண்டு, உங்கள் தொலைபேசியை வசதியான தூரத்தில் பிடியுங்கள்',
        'te': 'మీ ముఖాన్ని వృత్తంలో ఉంచి, మీ ఫోన్‌ను సరైన దూరంలో పట్టుకోండి',
        'kn': 'ನಿಮ್ಮ ಮುಖವನ್ನು ವೃತ್ತದೊಳಗೆ ಇರಿಸಿ ಮತ್ತು ನಿಮ್ಮ ಫೋನ್ ಅನ್ನು ಅನುಕೂಲಕರ ಅಂತರದಲ್ಲಿ ಹಿಡಿದುಕೊಳ್ಳಿ',
        'ml': 'നിങ്ങളുടെ മുഖം വൃത്തത്തിനുള്ളിൽ സൂക്ഷിച്ച്, ഫോൺ സൗകര്യപ്രദമായ ദൂരത്തിൽ പിടിക്കുക',
        'bn': 'আপনার মুখটি বৃত্তের মধ্যে রাখুন এবং ফোনটি আরামদায়ক দূরত্বে ধরুন',
    },
    keepFaceInstructionDesktop: {
        'en': 'Keep your face in the circle, hold your device at a comfortable distance',
        'hi': 'अपना चेहरा घेरे में रखें और उचित दूरी बनाए रखें',
        'gu': 'તમારો ચહેરો વર્તુળમાં રાખો અને આરામદાયક અંતર જાળવો',
        'mr': 'तुमचा चेहरा वर्तुळात ठेवा आणि योग्य अंतर ठेवा',
        'ta': 'உங்கள் முகத்தை வட்டத்திற்குள் வைத்துக்கொண்டு, வசதியான தூரத்தில் இருங்கள்',
        'te': 'మీ ముఖాన్ని వృత్తంలో ఉంచి, సరైన దూరంలో ఉండండి',
        'kn': 'ನಿಮ್ಮ ಮುಖವన్ను వృత్తదోళగే ఇరిసి మత్తు అనుకూలకర అన్తరదల్లిరి',
        'ml': 'നിങ്ങളുടെ മുഖം വൃത്തത്തിനുള്ളിൽ സൂക്ഷിച്ച്, സൗകര്യപ്രദമായ അകലം പാലിക്കുക',
        'bn': 'আপনার মুখটি বৃত্তের মধ্যে রাখুন এবং আরামদায়ক দূরত্ব বজায় রাখুন',
    },
    submitVideo: {
        'en': 'Submit',
        'hi': 'जमा करें',
        'gu': 'સબમિટ કરો',
        'mr': 'सबमिट करा',
        'ta': 'சமர்ப்பிக்கவும்',
        'te': 'సమర్పించండి',
        'kn': 'ಸಲ್ಲಿಸು',
        'ml': 'സമർപ്പിക്കുക',
        'bn': 'জমা দিন',
    },
    inPersonVerification: {
        'en': 'In-Person Verification (IPV) completed successfully. Client confirmation for opening the Trading and Demat account was captured',
        'hi': 'सामना-सामनी सत्यापन (IPV) सफलतापूर्वक पूरा हुआ। आपने नामांकन से सफलतापूर्वक बाहर निकलने का विकल्प चुना है। इस समय कोई और कार्रवाई आवश्यक नहीं है।',
        'gu': 'ઇન-પર્સન વેરિફિકેશન (IPV) સફળતાપૂર્વક પૂર્ણ થયું છે. તમે સફળતાપૂર્વક નામાંકનમાંથી બહાર નીકળવાનું પસંદ કર્યું છે. આ સમયે કોઈ વધારાની કાર્યવાહી જરૂરી નથી.',
        'mr': 'समक्ष पडताळणी (IPV) यशस्वीरित्या पूर्ण झाली आहे. आपण यशस्वीरित्या नामांकनातून बाहेर पडण्याचा पर्याय निवडला आहे. या वेळी आणखी कोणतीही कारवाई आवश्यक नाही.',
        'ta': 'நேரடியாகச் சரிபார்ப்பு (IPV) வெற்றிகரமாக நிறைவு பெற்றது. நீங்கள் பரிந்துரையிலிருந்து விலகுவதை வெற்றிகரமாகத் தேர்ந்தெடுத்துள்ளீர்கள். இந்த நேரத்தில் மேலும் எந்த நடவடிக்கையும் தேவையில்லை.',
        'te': 'సమక్ష ధృవీకరణ (IPV) విజయవంతంగా పూర్తయింది. మీరు విజయవంతంగా నామినేషన్ నుండి తప్పుకోవడం ఎంచుకున్నారు. ఈ సమయంలో మరే చర్య అవసరం లేదు.',
        'kn': 'ಸಮಕ್ಷ ಪರಿಶೀಲನೆ (IPV) ಯಶಸ್ವಿಯಾಗಿ ಪೂರ್ಣಗೊಂಡಿದೆ. ನೀವು ಯಶಸ್ವಿಯಾಗಿ ನಾಮನಿರ್ದೇಶನದಿಂದ ಹೊರಬರುವುದನ್ನು ಆಯ್ಕೆ ಮಾಡಿಕೊಂಡಿದ್ದೀರಿ. ಈ ಸಮಯದಲ್ಲಿ ಇನ್ನಷ್ಟು ಕ್ರಮ ಅಗತ್ಯವಿಲ್ಲ.',
        'ml': 'സമക്ഷ പരിശോധന (IPV) വിജയകരമായി പൂർത്തിയായി. നിങ്ങൾ വിജയകരമായി നാമനിർദ്ദേശത്തിൽ നിന്ന് പിന്മാറാൻ തിരഞ്ഞെടുത്തു. ഈ സമയത്ത് കൂടുതൽ നടപടികൾ ആവശ്യമായിട്ടില്ല.',
        'bn': 'সরাসরি যাচাই (IPV) সফলভাবে সম্পন্ন হয়েছে। আপনি সফলভাবে মনোনয়ন থেকে সরে যাওয়ার বিকল্পটি বেছে নিয়েছেন। এই মুহূর্তে আর কোনো পদক্ষেপের প্রয়োজন নেই।',
    },
    inPersonVerificationFailed: {
        'en': 'In-Person Verification (IPV) could not be completed. Client confirmation for opening the Trading and Demat account was not captured. Please retry the verification.',
        'hi': 'सामना-सामनी सत्यापन (IPV) पूरा नहीं हो सका। आपका नामांकन बाहर निकलने का अनुरोध संसाधित नहीं किया गया। कृपया सत्यापन दोबारा करें।',
        'gu': 'ઇન-પર્સન વેરિફિકેશન (IPV) પૂર્ણ થઈ શક્યું નથી. તમારો નામાંકન બહાર નીકળવાનો વિનંતી પ્રક્રિયા કરવામાં આવ્યો નથી. કૃપા કરીને ફરીથી વેરિફિકેશન કરો.',
        'mr': 'समक्ष पडताळणी (IPV) पूर्ण करता आली नाही. आपली नामांकनातून बाहेर पडण्याची विनंती प्रक्रिया झाली नाही. कृपया पुन्हा पडताळणी करा.',
        'ta': 'நேரடியாகச் சரிபார்ப்பு (IPV) முடிக்க முடியவில்லை. உங்கள் பரிந்துரையிலிருந்து விலகும் கோரிக்கை செயலாக்கப்படவில்லை. தயவுசெய்து மீண்டும் சரிபார்க்கவும்.',
        'te': 'సమక్ష ధృవీకరణ (IPV) పూర్తిచేయలేకపోయాము. మీ నామినేషన్ నుండి తప్పుకునే అభ్యర్థన ప్రాసెస్ కాలేదు. దయచేసి మళ్లీ ధృవీకరణ చేయండి.',
        'kn': 'ಸಮಕ್ಷ ಪರಿಶೀಲನೆ (IPV) ಪೂರ್ಣಗೊಳಿಸಲಾಗಲಿಲ್ಲ. ನಿಮ್ಮ ನಾಮನಿರ್ದೇಶನದಿಂದ ಹೊರಬರುವ ವಿನಂತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ.',
        'ml': 'സമക്ഷ പരിശോധന (IPV) പൂർത്തിയാക്കാൻ കഴിഞ്ഞില്ല. നിങ്ങളുടെ നാമനിർദ്ദേശത്തിൽ നിന്ന് പിന്മാറാനുള്ള അഭ്യർത്ഥന പ്രോസസ് ചെയ്തില്ല. ദയവായി വീണ്ടും പരിശോധന നടത്തുക.',
        'bn': 'সরাসরি যাচাই (IPV) সম্পন্ন করা যায়নি। আপনার মনোনয়ন থেকে সরে যাওয়ার অনুরোধ প্রক্রিয়াকৃত হয়নি। অনুগ্রহ করে পুনরায় যাচাই করুন।',
    },


}

export default declarationTextFallback;